import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 59A98F47-9067-492A-8454-42BEFA2391C1
 * name sigma
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sigma.svg
 * tags
 * - Math 
 */
export const SigmaIcon = createSvgIcon(<><path d="M18,6H8.83L14.83,12L8.83,18H18V20H6V18L12,12L6,6V4H18V6Z" /></>, 'SigmaIcon');
export default SigmaIcon